import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function PaperRouteMinorInfoContent() {
  return (
    <>
      <InfoPanelTitle>What is paper route income by a minor?</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Tell us if anyone under age 18 earned paper-route income as part of
          this business. Income from newspaper delivery performed by minors is
          generally exempt from self-employment tax.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'IRS guidance',
              url: 'https://www.irs.gov/publications/p334',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
